// extracted by mini-css-extract-plugin
module.exports = {"previewer":"Previewer_previewer__3_D4K","displayMobile":"Previewer_displayMobile__2mL76"};